<template lang="pug">
  vSelect.entrychannels-multiple-select(:value="selectedArray" :options="options" label="name" @input="onInput" :placeholder="loading ? 'Loading...' : placeholder" :disabled="loading === true || disabled === true" multiple)
</template>
<script>

import vSelect from 'vue-select'
import Core from '@/service/apis/Core'
import { isEqual } from '@/utils/lodash'

export default {
  props: {
    value: {
      type: null
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    options: [],
    selectedArray: [],
    placeholder: 'Select A Channel',
    loading: false
  }),
  created() {
    this.loading = true
    Core.listEntryChannelsV2({ size: 1000 })
      .then((resp) => {
        this.options = resp.data.content
        this.updateSelectedOptions()
      })
      .catch((e) => {
        this.placeholder = e.response.data.message
      })
      .then(() => { this.loading = false })
  },
  methods: {
    updateSelectedOptions() {
      const selectedIds = this.selectedArray.map((v) => v.id)
      const values = this.value.map((v) => v)
      const isEqualEntryChannel = isEqual(selectedIds.sort(), values.sort())
      if (!isEqualEntryChannel) {
        this.selectedArray = []
        const array = this.value
        array.forEach((v) => {
          const found = this.options.find((o) => o.id === v)
          if (found) {
            this.selectedArray.push(found)
          }
        })
      }
    },
    onInput(val) {
      this.$emit('input', val && val.length > 0 ? val.map((v) => v.id) : [])
    },
    getSelectedEntrychannel() {
      return this.selectedArray
    },
    setSelectedEntrychannel(entryChannel) {
      const exisiting = this.options.find((o) => o.id === entryChannel.id)
      if (!exisiting) {
        this.options.push(entryChannel)
      }
    }
  },
  watch: {
    value() {
      if (!this.loading) {
        this.updateSelectedOptions()
      }
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/EntrychannelsMultipleSelect.vue